var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('lookbookController', ['$scope', 'lookbookService', '$sce', 'loaderService', '$location',
    function ($scope, lookkbookService, $sce, loaderService, location) {

        $scope.initialize = function () {
            $scope.hasSearched = false;
            getActiveLookbooks();
        }

        $scope.loadLookbookFrame = function () {
            document.getElementById("lookbookFrame").src = $scope.selectedLookbook.lookbookUrl;
        }

        //#region Get Functions
        function getActiveLookbooks() {
            loaderService.show();
            lookkbookService.getActiveLookbooks().then(function (response) {
                $scope.hasSearched = true;

                if (response.data.length > 0) {
                    $scope.sortedLookbooks = response.data;
                    $scope.selectedLookbook = response.data[0];

                    if (location.$$absUrl.includes("?")) {
                        var splitUrl = location.$$absUrl.split("?");

                        if (splitUrl.length > 1 && splitUrl[1].includes("=")) {
                            var idSplit = splitUrl[1].split("=");

                            if (idSplit.length > 1) {
                                var id = idSplit[1];

                                for (var i = 0; i < $scope.sortedLookbooks.length; i++) {
                                    var tempId = $scope.sortedLookbooks[i].lookbookId;
                                    if (tempId.toLowerCase() == id.toLowerCase()) {
                                        $scope.selectedLookbook = $scope.sortedLookbooks[i];
                                    }
                                }
                            }
                        }
                    }
                } else {
                    $scope.sortedLookbooks = [];
                    $scope.selectedLookbook = null;
                }

                loaderService.hide();
            })
        }
        //#endregion

        //#region Click Functions
        $scope.viewLookbook = function (book) {
            $scope.selectedLookbook = book;
            document.getElementById("lookbookFrame").src = $scope.selectedLookbook.lookbookUrl;
            window.scroll(0, 0);
        }
        //#endregion
    }])
